import React, { useEffect, useState } from 'react';
import { createPortal} from 'react-dom'
import { Product} from '../../utils/interfaces/product'
import ProductCardQuickAdd from '../../utils/components/molecules/ProductCardQuickAdd'
import Icon from '../../utils/components/atoms/Icon'

interface SimilarVariantsProps {
  product: Product
  isOpen: boolean
  onClose: () => void
}
const SimilarVariantsDrawer: React.FC<SimilarVariantsProps> = ({
  product, onClose, isOpen
                                                     }) => {
  const [mounted, setMounted] = useState<boolean>(false);
  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    if (isOpen) {
      // Small delay to ensure initial state is rendered
      const timer = setTimeout(() => setShouldAnimate(true), 10);
      return () => clearTimeout(timer);
    } else {
      setShouldAnimate(false);
    }
  }, [isOpen]);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  // Handle ESC key
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  if (!mounted || !isOpen) return null;

  const filteredProducts = product.mainCategoryProducts?.filter(prod =>
    product.title !== prod.title
  );

  return createPortal (
    <>
        <div
          className={`w-full block w-full h-full fixed inset-0 z-30 bg-black backdrop-filter backdrop-blur-md backdrop-saturate-150 cursor-pointer transition delay-500 duration-500 ease-in-out ${isOpen ? 'bg-opacity-60' : 'bg-opacity-0'}`}
          onClick={onClose}
        ></div>

      {/* Drawer */}
      <div className={`block max-w-panel w-full h-full fixed top-0 bottom-0 transition duration-500 ease-in-out z-[38] overflow-scroll right-0 bg-[#E8EBED] ${shouldAnimate ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="px-4">
          <div className="sticky top-0 bg-[#E8EBED] py-4 z-10">
            <button onClick={onClose} className="cursor-pointer absolute right-0 p-2" type="button"
                    aria-label="Close Similar Variants Drawer">
              <Icon name="close" className="text-black w-5 h-5" strokeWidth={2} />
            </button>
            <h2 className="body-price">{product.mainCategory?.title}</h2>
          </div>


          <div className="grid grid-cols-2 gap-x-5 gap-y-5">
            {filteredProducts?.length &&
              filteredProducts.map((product) => (
                <ProductCardQuickAdd
                  key={product.handle}
                  product={product}
                />
              ))}
          </div>
        </div>
      </div>
    </>,
    document.body
  );
};

export default SimilarVariantsDrawer;